import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DrawerContext } from './drawerContext';
import * as styles from './header.module.css';
export function DrawerHeader({ children }) {
    const { closeDrawer } = useContext(DrawerContext);
    const { t } = useTranslation();
    return (_jsx("div", { slot: "heading", children: _jsxs("div", { className: "flex items-center justify-between gap-2", children: [children, _jsx("button", { className: styles.dismissibleButton, onClick: closeDrawer, "aria-label": t('general.close'), type: "button" })] }) }));
}
